import React from 'react';
import AppPublicProfile from '../app/[username]/page.jsx';

const PublicProfile = ({ username, onNavigate, skipAppHeader }) => {
  return <AppPublicProfile initialUsername={username} onNavigate={onNavigate} skipAppHeader={skipAppHeader} />;
};

export default PublicProfile;
